import { yupResolver } from '@hookform/resolvers/yup';
import { Drawer } from '@zorro/design-system/v2/Drawer';
import { CurrencyInput, Stack } from '@zorro/web/design-system';
import { useForm, useMonolithMutation } from '@zorro/web/ui-utils';
import { Controller } from 'react-hook-form';
import * as yup from 'yup';

import { FormFooter } from '../../../FormFooter';

const schema = yup.object({
  allowance: yup.number().required().min(0),
});

type FormFields = yup.InferType<typeof schema>;

type Props = {
  isOpened: boolean;
  onClose: () => void;
  onboardingPeriodId: string;
  currentAllowance?: number | null;
};

export const EditAllowanceDrawer = ({
  isOpened,
  onClose,
  onboardingPeriodId,
  currentAllowance,
}: Props) => {
  const { control, getValues, formState } = useForm<FormFields>({
    mode: 'all',
    resolver: yupResolver(schema),
    defaultValues: {
      allowance: currentAllowance ?? 0,
    },
  });

  const { isValid } = formState;

  const { tryMutate: updateAllowance } = useMonolithMutation({
    method: 'onboardingPeriodsControllerOverrideAllowance',
    successMessage: 'Allowance updated',
  });

  const handleSubmit = async () => {
    const { allowance } = getValues();
    await updateAllowance([
      onboardingPeriodId,
      {
        allowance,
      },
    ]);
    onClose();
  };

  return (
    <Drawer
      opened={isOpened}
      onClose={onClose}
      title="Edit allowance"
      footer={
        <FormFooter
          withPaper={false}
          secondaryLabel="Cancel"
          secondaryButtonProps={{ onClick: onClose }}
          primaryLabel="Confirm and continue"
          primaryButtonProps={{ onClick: handleSubmit, disabled: !isValid }}
        />
      }
    >
      <Stack>
        <Controller
          control={control}
          name="allowance"
          render={({ field }) => (
            <CurrencyInput
              {...field}
              prefix="$"
              size="md"
              decimalScale={0}
              thousandSeparator=","
            />
          )}
        />
      </Stack>
    </Drawer>
  );
};
